
















































































import Vue from 'vue';
import DreamDeleteModal, {DreamDeleteModalInterface} from '@/vue-components/dreams/DreamDeleteModal.vue';
import Curve1 from '@/assets/img/shapes/curves/curve-1.svg';
import EditIcon from '@/assets/img/icons/pencil.svg';
import DeleteIcon from '@/assets/img/icons/dash-circle.svg';
import { DreamWebDAO, SparkelloImageUtil, WebDream } from '@/web';
import autosize from 'autosize';

declare interface DreamViewData {
  localDream: WebDream | undefined;
  editMode: boolean;
  dreamImgUri: string;
}

export default Vue.extend({
  name: 'DreamView',
  props: {
    id: String,
  },
  components: {
    Curve1,
    EditIcon,
    DeleteIcon,
    DreamDeleteModal,
  },
  data(): DreamViewData {
    return {
      localDream: undefined,
      editMode: false,
      dreamImgUri: '',
    };
  },
  computed: {
    title(): string {
      const displayName =  this?.localDream?.displayName || this?.dream?.displayName ;
      if (displayName) {
        return 'Sparkello - ' + displayName;
      }
      return 'Sparkello - View Dream';
    },
    dream(): WebDream | undefined {
      //Get the dream data from the vuex store
      let dream: WebDream | undefined = this.$store.state.myDreams.index.get(this.id);

      //If the dream is not in the Vuex store it means the person has gone directly to this link
      //and the store is empty. Try getting it from the local data property which is set
      //asynchronously further down
      if (!dream && this.localDream) {
        dream = this.localDream;
      }

      return dream;
    },
  },
  created() {
    //On create check that the state store is populated, and if not then retrieve the individual
    // dream record.

    //Check the dream is in the store
    const dream: WebDream | undefined = this.$store.state.myDreams.index.get(this.id);

    if (dream) {
      SparkelloImageUtil.instance.getLargeImageSource(dream.image).then(uri => {
        this.$data.dreamImgUri = uri;
        console.log(uri);
        this.$forceUpdate();
      });
    }

    //If the dream is not in the store store retrieve the data remotely and set it
    // in the localDream data property
    if (!dream?.id) {
      DreamWebDAO.getInstance().getDream(this.id).then((value: WebDream | undefined) => {
        this.localDream = value;
      }).catch((error) => {
        console.log(error);
      });
    }

  },
  mounted() {
    //Sets the textarea inputs to autosize to content
    autosize(document.querySelectorAll('textarea'));
  },
  updated() {
    //Sets the textarea inputs to autosize to content
    autosize(document.querySelectorAll('textarea'));
  },
  watch: {
    localDream: function (newVal, oldVal) { // watch it
      console.log ('Local dream update detected', newVal, oldVal)
      if (newVal?.image && newVal?.image != oldVal?.image) {
        SparkelloImageUtil.instance.getLargeImageSource(newVal.image).then(uri => {
          this.$data.dreamImgUri = uri;
          this.$forceUpdate();
        });
      }
    },
  },
  methods: {
    showDeleteModal() {
      console.log('Really delete id ', this.id);
      (this.$refs.deleteModal as DreamDeleteModalInterface).show();
    },
  },
});
